import { UserPersona } from '@/domain/userPersonas/types';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Fragment } from 'react';

interface EndUsersContentProps {
  ProductUsers: UserPersona[];
}

export const EndUsersContent = ({ ProductUsers }: EndUsersContentProps) => {
  return (
    ProductUsers?.length > 0 && (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', m: 2, gap: 2 }}>
        {ProductUsers?.map((persona) => (
          <Fragment key={persona.idUserPersona}>
            <Chip label={persona.userPersona} variant="outlined" color="primary" />
          </Fragment>
        ))}
      </Box>
    )
  );
};

export default EndUsersContent;
